import { defineMessages } from 'react-intl';

export default defineMessages({
  seoTitle: {
    id: 'cc4.seo.permission.title',
    defaultMessage: '',
  },
  seoDescription: {
    id: 'cc4.seo.permission.description',
    defaultMessage: '',
  },
  permissionTitle: {
    id: 'cc4.form.permission.title',
    defaultMessage: 'Sign permission to handle your claim',
  },
  permissionSubTitle: {
    id: 'cc4.form.permission.sub-title',
    defaultMessage: `Draw your signature`,
  },
  permissionDescription: {
    id: 'cc4.form.permission.description',
    defaultMessage: `By digitally signing, you agree to our <tac>Terms and conditions</tac>, <prices>Pricing list</prices> and {poa, select, null {} other {<poa>Power of attorney</poa>}}{ppoa, select, null {} other {<ppoa>, Legal power of attorney</ppoa>}}{cpoa, select, null {} other {<cpoa>, Court power of attorney</cpoa>}} form(s).`,
  },
  permissionDescriptionFrenchCourt: {
    id: 'cc4.form.permission.description-french-court',
    defaultMessage: `By digitally signing, you agree to our <tac>Terms and conditions</tac> and {poa, select, null {} other {<poa>Power of attorney</poa>}}{ppoa, select, null {} other {<ppoa>, Legal power of attorney</ppoa>}}{cpoa, select, null {} other {<cpoa>, Court power of attorney</cpoa>}} form(s).`,
  },
  permissionSignature: {
    id: 'cc4.form.permission.signature',
    defaultMessage:
      'Click and draw your signature as it appears in your passport',
  },
  submitContinue: {
    id: 'cc4.form.permission.button.submit-continue',
    defaultMessage: 'Continue',
  },
  permissionBackButton: {
    id: 'cc4.form.permission.button.back',
    defaultMessage: 'Back',
  },
  saveSignatureButton: {
    id: 'cc4.form.permission.save-signature-button',
    defaultMessage: 'Save signature',
  },
  asideText: {
    id: 'cc4.form.permission.aside-text',
    defaultMessage:
      'We need your signature to represent you in front of the airline.',
  },
  dangerMessage: {
    id: 'cc4.form.permission.error-message',
    defaultMessage:
      'Unfortunately, due to an unexpected error, your data could not be saved. Please restart the process on our homepage and provide all the required information again. Our apologies for the inconvenience.',
  },
  permissionDescriptionJarolim: {
    id: 'cc4.form.permission.description-jarolim',
    defaultMessage:
      'You hereby sign {ppoa, select, null {} other {<ppoa>, Assignment of Credit</ppoa>}} (type of Power of Attorney) by which you transfer your claim (rights) to us. We are the only ones that are allowed to collect the claim, take legal action(s) and be paid. If the claim is awarded, we will pay you according to our <prices>Pricing List</prices> and the <tac>Terms and Conditions</tac>. Be aware: If the airline does pay you directly while we are working on your claim then this payment may be reclaimed by the airline.',
  },
});
